import React, { useState } from "react";
import ImageDots from "../../images/icn-dots.svg";
import EmotiiWelcome from "../../images/emotii-welcome.png";
import PlaceholderLogo from "../../images/logo-placeholder.png";
import { useAuth0 } from "@auth0/auth0-react";
import classNames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import {
  incrementCurrentSlide,
  incrementPeekSlide,
  setCurrentSlide,
  setPeekSlide,
} from "../../store/slices/slides";
function Homepage() {
  const { user, logout } = useAuth0();
  const dispatch = useDispatch();
  const { totalSlides } = useSelector((state) => state.slides);
  const { results, data: assessment } = useSelector(
    (state) => state.assessment
  );
  const [dropdown, setDropdown] = useState(false);

  return (
    <div className="h-full bg-emotii-welcome">
      <div className="block-emotti ">
        <div className="block-welcome">
          <div className="user-detail">
            <span
              onClick={() => setDropdown((d) => !d)}
              className="cursor-pointer"
            >
              <img src={ImageDots} alt="" className="" /> Hello,{" "}
              <a href="#">
                {assessment?.patient?.firstName} {assessment?.patient?.lastName}
              </a>
            </span>

            <div
              className={classNames("drop-down-user hidden", {
                "show-drop-down": dropdown,
              })}
              onBlur={() => setDropdown((d) => false)}
              tabIndex={dropdown ? 0 : -1}
            >
              <div className="trianlge"></div>
              <ul>
                <li>
                  <a
                    href="#"
                    onClick={() => {
                      dispatch(setPeekSlide(totalSlides - 1));
                      dispatch(setCurrentSlide(totalSlides - 1));
                    }}
                  >
                    My Account
                  </a>
                </li>
                <li>
                  <a onClick={() => logout()} href="#" className="logout-text">
                    Logout
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="text-right">
            <div className="logged-user-welcome">
              <img src={EmotiiWelcome} alt="" />
              <h1 className="">
                Welcome to
                <span className="text-4xl block">
                  {" "}
                  <strong className="font-black">
                    <i>Emotii</i>
                  </strong>{" "}
                </span>
              </h1>
            </div>

            <i className="mb-3 block">
              How you{" "}
              <strong>
                <u>feel</u>
              </strong>{" "}
              affects{" "}
              <strong>
                <u>everything</u>
              </strong>
            </i>
          </div>

          <div className="block-button ">
            <a
              href="#"
              onClick={() => {
                dispatch(incrementCurrentSlide());
                dispatch(incrementPeekSlide());
              }}
              className="text-right"
            >
              <span>Take a new</span>
              <i>Emotii</i>
            </a>
            <a
              href="#"
              className={classNames("text-left", {
                "opacity-50 pointer-events-none": !results?.length,
              })}
              onClick={() => {
                dispatch(setPeekSlide(totalSlides - 2));
                dispatch(setCurrentSlide(totalSlides - 2));
              }}
            >
              <span>View</span>
              My
              <br /> Results
            </a>
          </div>

          <p class="text-lg leading-[22px]">
            "Knowing yourself is the beginning of all wisdom." (Aristotle)
          </p>
        </div>
      </div>
    </div>
  );
}

export default Homepage;
